import React from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Layout from './components/Layout/Layout';
import AccueilPage from './pages/Accueil/AccueilPage';
import SeancesPage from './pages/Seances/SeancesPage';
import LoginPage from './pages/Login/LoginPage';
import PasswordResetPage from './pages/Login/PasswordRresetPage';
import SeancePage from './pages/Seances/SeancePage';
import ActivitesPage from './pages/Activites/ActivitesPage';
import ActivitePage from './pages/Activites/ActivitePage';
import {ModalProvider} from './contexts/ModalContext';
import './root.css';
import LoadDataToLocalStorage from "./maquette/LoadDataToLocalStorage";
import PlanningMainPage from "./pages/Planning/PlanningMainPage";
import ProfilPage from "./pages/Utilisateur/ProfilPage";
import ListTestPage from "./pages/Test/ListTestPage";
import ListeUtilisateursPage from "./pages/Utilisateur/ListeUtilisateursPage";
import {UserProvider} from "./contexts/UserContext";
import ProtectedRouteWithRoles from "./components/Login/ProtectedRouteWithRoles";
import ErrorPage from "./pages/Erreurs/ErrorPage";
import FilterTestPage from "./pages/Test/FilterTestPage";
import ChartsTestPage from "./pages/Test/ChartsTestPage";
import PrivateRoute from "./components/Login/PrivateRoute";
import ApiDataTestPage from "./pages/Test/ApiDataTestPage";
import CardGridTestPage from "./pages/Test/CardGridTestPage";
import ReportPage from "./pages/Report/ReportPage";
import UserReportsPage from "./pages/Report/UserReportsPage";
import {AlertProvider} from "./contexts/AlertContext";
import UploadFileTestPage from "./pages/Test/UploadFileTestPage";
import ProtectedRouteWithStatus from "./components/Login/ProtectedRouteWithStatus";
import UserStatusPage from "./pages/Utilisateur/UserStatusPage";
import RedirectBasedOnUser from "./components/Login/RedirectBasedOnUser";
import ConfirmTokenPage from "./pages/Utilisateur/ConfirmTokenPage";
import ConfirmationProfilPage from "./pages/Utilisateur/ConfirmationProfilPage";
import PasswordNewPage from "./pages/Login/PasswordNewPage";
import {BreadcrumbProvider} from "./contexts/BreadcrumbContext";
import MainStatsPage from "./pages/Stats/MainStatsPage";
import AdminDashboardPage from "./pages/Admin/Dashboard/AdminDashboardPage";
import AdminEntreprisesPage from "./pages/Admin/Entreprises/AdminEntreprisesPage";
import AdminEntreprisePage from "./pages/Admin/Entreprises/AdminEntreprisePage";
import AdminContratsPage from "./pages/Admin/Contrats/AdminContratsPage";
import AdminContratPage from "./pages/Admin/Contrats/AdminContratPage";
import AdminActivitesPage from "./pages/Admin/Activites/AdminActivitesPage";
import AdminActivitePage from "./pages/Admin/Activites/AdminActivitePage";
import AdminSeancesPage from "./pages/Admin/Seances/AdminSeancesPage";
import AdminSeancePage from "./pages/Admin/Seances/AdminSeancePage";
import AdminParticipationsPage from "./pages/Admin/Seances/AdminParticipationsPage";
import AdminUtilisateursPage from "./pages/Admin/Utilisateurs/AdminUtilisateursPage";
import AdminUtilisateurPage from "./pages/Admin/Utilisateurs/AdminUtilisateurPage";
import AdminRolesPage from "./pages/Admin/Roles/AdminRolesPage";
import AdminRolePage from "./pages/Admin/Roles/AdminRolePage";
import AdminRoleJustificatifsPage from "./pages/Admin/Roles/AdminRoleJustificatifsPage";
import AdminSalariesPage from "./pages/Admin/Utilisateurs/AdminSalariesPage";
import AdminJustificatifTypesPage from "./pages/Admin/JustificatifTypes/AdminJustificatifTypesPage";
import AdminJustificatifTypePage from "./pages/Admin/JustificatifTypes/AdminJustificatifTypePage";
import AdminActiviteTypesPage from "./pages/Admin/ActiviteTypes/AdminActiviteTypesPage";
import AdminActiviteTypePage from "./pages/Admin/ActiviteTypes/AdminActiviteTypePage";
import SearchTestPage from "./pages/Test/SearchTestPage";
import AdminParticipationPage from "./pages/Admin/Seances/AdminParticipationPage";
import AdminSeancesAllPage from "./pages/Admin/Seances/AdminSeancesAllPage";
import TabSeancesStatsPage from "./pages/Stats/TabSeancesStatsPage";
import TabUsersStatsPage from "./pages/Stats/TabUsersStatsPage";
import TabActiviteTypesStatsPage from "./pages/Stats/TabActiviteTypesStatsPage";
import AdminAbsencesPage from "./pages/Admin/Absences/AdminAbsencesPage";
import AdminCrmMainPage from "./pages/Admin/Crm/AdminCrmMainPage";
import AdminCrmUserOptinPage from "./pages/Admin/Crm/AdminCrmUserOptinPage";
import AdminCrmTypesPage from "./pages/Admin/Crm/AdminCrmTypesPage";
import AdminCrmUserHistoriquePage from "./pages/Admin/Crm/AdminCrmUserHistoryPage";
import {LoadingProvider} from './contexts/LoadingContext';
import EnrolementProfilPage from "./pages/Utilisateur/EnrolementProfilPage";
import CrmUserHistoryPage from "./pages/Crm/CrmUserHistoryPage";
import RedirectToSeanceAdmin from "./components/Admin/Seances/RedirectToSeanceAdmin";
import SeancesMenuPage from "./pages/Seances/SeancesMenuPage";
import ImportSalariePage from "./pages/Utilisateur/ImportSalariéPage";
import Cgu from "./pages/Cgu/Cgu";
import LocationTracker from "./components/Tracker/LocationTracker";
import CacheOut from "./pages/Cache/CacheOut";

function App() {
    return (
        <UserProvider>
            <Router>
                <ModalProvider>
                    <AlertProvider>
                        <LocationTracker>
                            <BreadcrumbProvider>
                                <LoadingProvider>
                                    <Routes>
                                        {process.env.REACT_APP_MODE === 'maquette' && (
                                            <Route path="/load_data" element={<LoadDataToLocalStorage/>}/>
                                        )}

                                        {process.env.REACT_APP_MODE === 'dev' && (
                                            <Route path="/get_confirm_token/:user"
                                                   element={<ConfirmTokenPage/>}/>
                                        )}

                                        <Route path="/login" element={<LoginPage/>}/>
                                        <Route path="/password-reset" element={<PasswordResetPage/>}/>
                                        <Route path="/password-new/:token/:mail" element={<PasswordNewPage/>}/>
                                        <Route path="/cacheout" element={<CacheOut />} />

                                        <Route element={<ProtectedRouteWithRoles requiredRoles={['ROLE_ADMIN', 'ROLE_SUPER_ADMIN']}/>}>
                                            <Route path="/testapi" element={<ApiDataTestPage/>}/>
                                        </Route>

                                        <Route path="/" element={<Layout/>}>
                                            <Route path="profil/confirmation/:token/:mail"
                                                   element={<ConfirmationProfilPage/>}/>
                                            <Route path="profil/enrolement/:token/:uid"
                                                   element={<EnrolementProfilPage/>}/>

                                            <Route path="cgu" element={<Cgu/>} />

                                            <Route element={<PrivateRoute/>}>
                                                <Route path="/userstatus" element={<UserStatusPage/>}/>
                                                <Route index element={<RedirectBasedOnUser/>}/>
                                                <Route element={<ProtectedRouteWithStatus requiredStatus={[1]}/>}>
                                                    <Route path="accueil" element={<AccueilPage/>}/>

                                                    <Route path="seances/">
                                                        <Route path="" element={<SeancesMenuPage/>}/>
                                                        <Route path="all" element={<SeancesPage/>}/>
                                                        <Route path="enregistrees" element={<SeancesPage/>}/>
                                                        <Route path="disponibles" element={<SeancesPage/>}/>
                                                        <Route path="effectuees" element={<SeancesPage/>}/>
                                                        <Route path="date/:jour" element={<SeancesPage/>}/>
                                                        <Route path="seance/:id" element={<SeancePage/>}/>

                                                        <Route path="referent">
                                                            <Route index element={<SeancesPage/>}/>
                                                            <Route path="disponibles" element={<SeancesPage/>}/>
                                                            <Route path="effectuees" element={<SeancesPage/>}/>
                                                        </Route>

                                                        <Route path="coach">
                                                            <Route index element={<SeancesPage/>}/>
                                                            <Route path="disponibles" element={<SeancesPage/>}/>
                                                            <Route path="effectuees" element={<SeancesPage/>}/>
                                                        </Route>
                                                    </Route>

                                                    <Route path="activites">
                                                        <Route index element={<ActivitesPage/>}/>

                                                        <Route path="" element={<ActivitesPage/>}/>
                                                        <Route path="myCompany" element={<ActivitesPage/>}/>
                                                        <Route path="activite/:id" element={<ActivitePage/>}/>
                                                    </Route>

                                                    <Route path={"salaries/"} element={<ProtectedRouteWithRoles
                                                        requiredRoles={['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_REFERENT']}/>}>
                                                        <Route index
                                                               element={<ListeUtilisateursPage title={"Salariés"}/>}/>
                                                        <Route path="crm_history"
                                                               element={<CrmUserHistoryPage/>}/>
                                                        <Route path="participants"
                                                               element={<ListeUtilisateursPage
                                                                   title={"Participants"}/>}/>
                                                        <Route path="import" element={<ImportSalariePage/>}/>
                                                    </Route>

                                                    <Route path={"stats"} element={<ProtectedRouteWithRoles
                                                        requiredRoles={['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_REFERENT']}/>}>
                                                        <Route index element={<MainStatsPage/>}/>
                                                        <Route path="main" element={<MainStatsPage/>}/>
                                                        <Route path="seances" element={<TabSeancesStatsPage/>}/>
                                                        <Route path="activite_types"
                                                               element={<TabActiviteTypesStatsPage/>}/>
                                                        <Route path="users" element={<TabUsersStatsPage/>}/>
                                                        <Route path={"mois"} element={<MainStatsPage/>}/>
                                                    </Route>

                                                    <Route path="planning" element={<PlanningMainPage/>}/>

                                                    <Route element={<ProtectedRouteWithRoles
                                                        requiredRoles={['ROLE_ADMIN', 'ROLE_SUPER_ADMIN']}/>}>
                                                        <Route path="test/">
                                                            <Route path="list" element={<ListTestPage/>}/>
                                                            <Route path="filter" element={<FilterTestPage/>}/>
                                                            <Route path="charts" element={<ChartsTestPage/>}/>
                                                            <Route path="card" element={<CardGridTestPage/>}/>
                                                            <Route path="search" element={<SearchTestPage/>}/>
                                                            <Route path="entreprise/logo"
                                                                   element={<UploadFileTestPage/>}/>
                                                        </Route>
                                                    </Route>
                                                </Route>

                                                <Route path="profil" element={<ProfilPage/>}/>
                                                <Route path="profil/justificatifs" element={<ProfilPage/>}/>

                                                <Route path="report"
                                                       element={<ReportPage title={"Signaler un problème"}/>}/>
                                                <Route path="reports/:id"
                                                       element={<UserReportsPage title={"Signalements"}/>}/>

                                                <Route path="unauthorized"
                                                       element={<ErrorPage title={"Accès non autorisé"}/>}/>
                                                <Route path="unauthorized/:userstatus"
                                                       element={<ErrorPage title={"Accès non autorisé"}/>}/>
                                                <Route path="*" element={<ErrorPage title={"Page non trouvée"}/>}/>

                                                <Route
                                                    element={<ProtectedRouteWithRoles requiredRoles={['ROLE_ADMIN', 'ROLE_SUPER_ADMIN']}/>}>
                                                    <Route path="admin">
                                                        <Route index element={<AdminDashboardPage/>}/>

                                                        <Route path="entreprises">
                                                            <Route index element={<AdminEntreprisesPage/>}/>
                                                            <Route path=":entrepriseId">
                                                                <Route index element={<AdminEntreprisePage/>}/>
                                                                <Route path="salaries">
                                                                    <Route index element={<AdminSalariesPage/>}/>
                                                                </Route>

                                                                <Route path="contrats">
                                                                    <Route index element={<AdminContratsPage/>}/>
                                                                    <Route path=":contratId">
                                                                        <Route index element={<AdminContratPage/>}/>
                                                                        <Route path="activites">
                                                                            <Route index
                                                                                   element={<AdminActivitesPage/>}/>
                                                                            <Route path=":activiteId">
                                                                                <Route index
                                                                                       element={<AdminActivitePage/>}/>
                                                                                <Route path="seances">
                                                                                    <Route index element={
                                                                                        <AdminSeancesPage/>}/>
                                                                                    <Route path=":seanceId">
                                                                                        <Route index
                                                                                               element={
                                                                                                   <AdminSeancePage/>}/>
                                                                                        <Route path="participations">
                                                                                            <Route index element={
                                                                                                <AdminParticipationsPage/>}/>
                                                                                            <Route
                                                                                                path=":participationId"
                                                                                                element={
                                                                                                    <AdminParticipationPage/>}/>
                                                                                        </Route>
                                                                                    </Route>
                                                                                </Route>
                                                                            </Route>
                                                                        </Route>
                                                                    </Route>
                                                                </Route>
                                                            </Route>
                                                        </Route>
                                                        <Route path="utilisateurs">
                                                            <Route index element={<AdminUtilisateursPage/>}/>
                                                            <Route path=":utilisateurId"
                                                                   element={<AdminUtilisateurPage/>}/>
                                                        </Route>
                                                        <Route path="roles">
                                                            <Route index element={<AdminRolesPage/>}/>
                                                            <Route path=":roleName">
                                                                <Route index element={<AdminRolePage/>}/>
                                                                <Route path="justificatifs"
                                                                       element={<AdminRoleJustificatifsPage/>}/>
                                                            </Route>
                                                        </Route>
                                                        <Route path={"justificatifs"}>
                                                            <Route path={"types"}>
                                                                <Route index element={<AdminJustificatifTypesPage/>}/>
                                                                <Route path={":justificatifTypeId"}
                                                                       element={<AdminJustificatifTypePage/>}/>
                                                            </Route>
                                                        </Route>
                                                        <Route path={"activites"}>
                                                            <Route path={"types"}>
                                                                <Route index element={<AdminActiviteTypesPage/>}/>
                                                                <Route path={":activiteTypeId"}
                                                                       element={<AdminActiviteTypePage/>}/>
                                                            </Route>
                                                        </Route>
                                                        <Route path={"seances"}>
                                                            <Route index element={<AdminSeancesAllPage/>}/>
                                                            <Route path={":seanceId"}
                                                                   element={<RedirectToSeanceAdmin/>}/>
                                                        </Route>
                                                        <Route path={"absences"}>
                                                            <Route index element={<AdminAbsencesPage/>}/>
                                                        </Route>
                                                        <Route path={"crm"}>
                                                            <Route index element={<AdminCrmMainPage/>}/>
                                                            <Route path={"user_history"}
                                                                   element={<AdminCrmUserHistoriquePage/>}/>
                                                            <Route path={"user_optin"}
                                                                   element={<AdminCrmUserOptinPage/>}/>
                                                            <Route path={"types"}
                                                                   element={<AdminCrmTypesPage/>}/>
                                                        </Route>
                                                    </Route>
                                                </Route>
                                            </Route>
                                        </Route>
                                    </Routes>
                                </LoadingProvider>
                            </ BreadcrumbProvider>
                        </LocationTracker>
                    </AlertProvider>
                </ModalProvider>
            </Router>
        </UserProvider>
    );
}

export default App;
